import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./utils/authInterceptor";
import App from "./App";

// IMPORTANT: Unregister all service workers to prevent update dialogs
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
  
  // Also clear all caches
  if ('caches' in window) {
    caches.keys().then(names => {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}

// Remove platform watermarks/badges
const removeWatermarks = () => {
  // Find and remove elements containing "Made with Emergent" or similar
  const selectors = [
    '[class*="emergent"]',
    '[id*="emergent"]',
    'a[href*="emergentagent.com"]:not([href*="preview"])',
    'div[style*="Made with"]'
  ];
  
  selectors.forEach(selector => {
    try {
      document.querySelectorAll(selector).forEach(el => {
        if (el && !el.closest('#root')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.remove();
        }
      });
    } catch (e) {}
  });
  
  // Remove fixed position elements in bottom-right that aren't part of our app
  document.querySelectorAll('body > div').forEach(el => {
    if (!el.id && !el.className && el.id !== 'root') {
      const style = window.getComputedStyle(el);
      if (style.position === 'fixed' && 
          (style.bottom === '0px' || parseInt(style.bottom) < 50) &&
          (style.right === '0px' || parseInt(style.right) < 50)) {
        el.style.display = 'none';
        el.remove();
      }
    }
  });
};

// Run immediately and observe for dynamic injection
removeWatermarks();
const observer = new MutationObserver(removeWatermarks);
observer.observe(document.body, { childList: true, subtree: true });

// Also run after a delay to catch late-loaded elements
setTimeout(removeWatermarks, 1000);
setTimeout(removeWatermarks, 3000);
setTimeout(removeWatermarks, 5000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
